import { Fancybox } from "@fancyapps/ui";
import { useEffect } from "react";

const Videos = () => {

    useEffect(() => {
        Fancybox.bind("[data-fancybox]", {});
    }, []);

    return (
        <>
            <section className="main_slider">
                <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <div className="inr_bnr_bg">
                                <img src="images/inrbnr.png" className="img-fluid" alt="..." />
                            </div>
                            <div className="carousel-caption">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className=" col-lg-6 col-md-8 col-sm-4 align-self-center">
                                            <div className="banner_text wow animate__animated animate__slideInLeft" data-wow-delay="0.3s" data-wow-duration="1s">
                                                <h1>Videos</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="Videos all-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 wow animate__animated animate__fadeInDown" data-wow-delay="0.3s" data-wow-duration="2s">
                            <div className="heading">
                                <h2>
                                    Videos
                                </h2>
                                <p>
                                    Duis aute irure dolor in reprehenderit in voluptataboreet dolore magna aliqua. Ut enim ad
                                    minim ve lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor
                                    incididunt
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6 wow animate__animated animate__fadeInUp" data-wow-delay="0.4s" data-wow-duration="2s">
                            <div className="video_main">
                                <img src="images/v-1.jpg" alt />
                                <a href="images/dummy-vid.mp4" data-fancybox="gallery">
                                    <i className="fa-solid fa-play" />
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 wow animate__animated animate__fadeInUp" data-wow-delay="0.4s" data-wow-duration="2s">
                            <div className="video_main">
                                <img src="images/v-2.jpg" alt />
                                <a href="images/dummy-vid.mp4" data-fancybox="gallery">
                                    <i className="fa-solid fa-play" />
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 wow animate__animated animate__fadeInUp" data-wow-delay="0.4s" data-wow-duration="2s">
                            <div className="video_main">
                                <img src="images/v-3.jpg" alt />
                                <a href="images/dummy-vid.mp4" data-fancybox="gallery">
                                    <i className="fa-solid fa-play" />
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 wow animate__animated animate__fadeInUp" data-wow-delay="0.4s" data-wow-duration="2s">
                            <div className="video_main">
                                <img src="images/v-4.jpg" alt />
                                <a href="images/dummy-vid.mp4" data-fancybox="gallery">
                                    <i className="fa-solid fa-play" />
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 wow animate__animated animate__fadeInUp" data-wow-delay="0.4s" data-wow-duration="2s">
                            <div className="video_main">
                                <img src="images/v-5.jpg" alt />
                                <a href="images/dummy-vid.mp4" data-fancybox="gallery">
                                    <i className="fa-solid fa-play" />
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 wow animate__animated animate__fadeInUp" data-wow-delay="0.4s" data-wow-duration="2s">
                            <div className="video_main">
                                <img src="images/v-6.jpg" alt />
                                <a href="images/dummy-vid.mp4" data-fancybox="gallery">
                                    <i className="fa-solid fa-play" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Videos